var map = {
	"./icon-bag.svg": 5072,
	"./icon-ball.svg": 8005,
	"./icon-beer.svg": 632,
	"./icon-cal-star.svg": 4195,
	"./icon-cal.svg": 4286,
	"./icon-headphone.svg": 6348,
	"./icon-ticket.svg": 3102,
	"./icon-tv.svg": 6480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3316;